/**
 * Recently-opened tickets, tracked client-side (localStorage) so the global
 * search dropdown can show them instantly and the quick-search API can apply
 * its "recently opened" ranking boost.
 */

const KEY = 'atlas.recentTickets';
const MAX = 12;

export interface RecentTicket {
  id: string;
  code: string;
  title: string;
  at: number;
}

function read(): RecentTicket[] {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? (JSON.parse(raw) as RecentTicket[]) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function recordRecentTicket(t: { id: string; code: string; title: string }) {
  if (!t.id || !t.code) return;
  const list = read().filter((r) => r.id !== t.id);
  list.unshift({ id: t.id, code: t.code, title: t.title, at: Date.now() });
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* quota — ignore */
  }
}

export function getRecentTickets(): RecentTicket[] {
  return read();
}

export function getRecentTicketIds(): string[] {
  return read().map((r) => r.id);
}
